import {Chip} from "@mui/material";
import {colors as c} from "./colors";

const variantColors = {
  success: {backgroundColor: c.successBg, color: c.successText},
  error: {backgroundColor: c.errorBg, color: c.errorText},
  warning: {backgroundColor: c.warningBg, color: c.warningText},
  info: {backgroundColor: c.infoBg, color: c.infoText},
  default: {backgroundColor: c.neutralBg, color: c.neutralText},
};

const StatusChip = ({label, variant = "default", color, icon, size, sx}) => {
  const isSmall = size === "small";
  const chipColors = color || variantColors[variant] || variantColors.default;

  return (
      <Chip
          label={label}
          icon={icon}
          size="small"
          sx={{
            height: isSmall ? "18px" : "24px",
            fontSize: isSmall ? "10px" : "12px",
            fontWeight: 600,
            backgroundColor: chipColors.backgroundColor || chipColors.bg,
            color: chipColors.color || chipColors.text,
            "& .MuiChip-label": {
              padding: isSmall ? "0 4px" : "0 8px",
            },
            "& .MuiChip-icon": {
              marginRight: icon ? "2px" : "0",
              marginLeft: icon ? "4px" : "0",
            },
            ...sx,
          }}
      />
  );
};

export default StatusChip;
